import { Tab, Tabs } from '@mui/material';
import { ReactElement } from 'react';

import classes from './ParameterTabs.module.scss';

export interface ParameterTab<T> {
  label: string;
  value: T;
}

export interface ParameterTabsProps<T> {
  currentTab: T;
  tabs: ParameterTab<T>[];
  onChange: (value: T) => void;
}

const ParameterTabs = <T,>({
  currentTab,
  tabs,
  onChange,
}: ParameterTabsProps<T>): ReactElement => {
  return (
    <div className={classes.Container}>
      <Tabs
        value={currentTab}
        onChange={(_, value) => onChange(value)}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        TabScrollButtonProps={{
          classes: { disabled: classes.ScrollButtonDisabled },
        }}
        classes={{
          scrollButtons: classes.ScrollButtons,
          flexContainer: classes.Tabs,
        }}
      >
        {tabs?.map((t, i) => (
          <Tab
            classes={{ selected: classes.TabSelected }}
            label={t.label}
            value={t.value}
            key={i}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default ParameterTabs;
